import { render, staticRenderFns } from "./cameraComponent.vue?vue&type=template&id=1c76a1ac&"
import script from "./cameraComponent.vue?vue&type=script&lang=ts&"
export * from "./cameraComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports